<template>

  <div v-if="isShow" class="dialog_box">
      <div class="dialog_content">
          <div class="header">
              <span class="header_no" @click="dialogCloseBtn">不再提示</span>
              <span class="header_close" @click="dialogCloseBt">关闭</span>
          </div>
          <div class="img_box">
              <div class="img_left">
                  <img class="bg untitled_apple" src="https://mpstatic.13yx.com/h5sdk/images/Untitled.png" alt="">
                  
                  <img class="game_icon" src="https://sdk-static.zhangyuqu.com/icon/app/slzs.png" alt="">
                  <img class="bule" src=" https://mpstatic.13yx.com/h5sdk/images/bluelujing.png" alt="">
              </div>
              <div class="img_right">
                  <img class="wenanm message_apple" src=" https://mpstatic.13yx.com/h5sdk/images/wenan.png" alt="">
                  
                  <img class="big_icon" src="https://sdk-static.zhangyuqu.com/icon/app/slzs.png" alt="">
                  <span class="game_title">{{ appName }}</span>
              </div>
          </div>
          <div class="footer_box">
              <img class="footer_bg" src=" https://mpstatic.13yx.com/h5sdk/images/tishiwenzhi.png" alt="">
              <img class="gif_img" src=" https://mpstatic.13yx.com/h5sdk/images/sa.gif" alt="">
          </div>
      </div>
 
  </div>    
</template>

<script>
/* 用户相关 */
import { setStorage, getStorage } from '@/libs/utils';

export default {
  name: 'iosTips',
  data(){
      return {
          isShow:true,
          appName:'',
      }
  },
  mounted() {
    this.$store.dispatch('user/getCacheState');
    this.appName = this.$store.state.user.app_name;
  },
  methods:{
      dialogCloseBt(){
          this.isShow = false;
      },
      dialogCloseBtn(){
         
        this.isShow = false;
        setStorage('iosTips',1);
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .dialog_box {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      z-index: 9999999;
  }

  .dialog_content {
      max-width: 375px;
      height: 100vh;
      margin: 0 auto;
  }

  .header {
      width: 100%;
      height: 30px;
      margin-top: 20px;
  }
  .header span {
      display: block;
  }

  .header_no {
      float: left;
      font-size: 14px;
      line-height: 28px;
      margin-left: 15px;
      color: #dddddd;
  }

  .header_close {
      color: #ffffff;
      float: right;
      font-size: 15px;
      width: 77px;
      height: 28px;
      border: 1px solid #ffffff;
      border-radius: 14px;
      text-align: center;
      line-height: 28px;
      margin-right: 15px;
  }
  img {
      vertical-align: top;
  }
  .img_box {
      width: 100%;
      height: 346px;
      margin-top: 26px;
  }

  .img_left {
      position: relative;
      width: 182px;
      height: 100%;
      float: left;
  }

  .img_left .bg {
      width: 100%;
      height: 100%;
  }

  .game_icon {
      width: 21px;
      height: 21px;
      position: absolute;
      bottom: 169px;
      right: 37.5px;
  }
  .bule {
      position: absolute;
      width: 183px;
      height: 131px;
      top: 161px;
      right: -131px;
  }
  .img_right {
      float: left;
      padding-top: 1px;
  }
  .game_title {
        display: block;
        width: 75px;
        font-size: 15px;
        color: #ffffff;
        margin-top: 45px;
        margin-left: 58.5px;
        text-align: center;
    }
  .img_right .wenanm {
      width: 173px;
      height: 117px;
      margin-top: 45px;
      display: block;
  }

  .big_icon {
      width: 87px;
      height: 87px;
      display: block;
      position: relative;
      z-index: 10;
      top: 43px;
      left: 53px;
      border-radius: 10px;
  }

  .footer_box {
      position: fixed;
      bottom: 6px;
      left: 0;
      width: 100%;
      height: 119px;
  }
  .footer_bg {
      display: block;
      width: 365px;
      height: 76px;
      margin: 0 auto;
  }
  .gif_img {
      display: block;
      width: 16px;
      height: 25px;
      margin: 12px auto 0;
  }
</style>
